import { queryOptions } from '@tanstack/react-query';
import type { GetUserResponseStatsData } from 'generated/openapi';

import { PrivateApi } from '@/shared/api/httpClient';
import type { ReplacePathParams } from '@/shared/utils/pathParams';

import {
  type ChatResponseStatsRaw,
  transformResponseStats,
} from '../../types/responseStats';

export interface ResponseStatsKeyParams {
  userId: string;
}

const getResponseStatsUrl = (
  userId: string,
): ReplacePathParams<GetUserResponseStatsData['url']> =>
  `profiles/${userId}/response-stats`;

export const getResponseStatsKey = ({ userId }: ResponseStatsKeyParams) =>
  ['response-stats', userId] as const;

export const getResponseStatsOptions = (params: ResponseStatsKeyParams) =>
  queryOptions({
    queryKey: getResponseStatsKey(params),
    queryFn: async ({ signal }) =>
      PrivateApi.get(getResponseStatsUrl(params.userId), {
        signal,
      }).json<ChatResponseStatsRaw>(),
    select: transformResponseStats,
    staleTime: 5 * 60 * 1000,
  });
